import { MESSAGE_TYPES } from "./types.js";
import { ALLOWED_ORIGINS } from "./validateOrigin.js";
const MESSAGE_TYPE_SET = new Set(MESSAGE_TYPES);
export function isValidMessage(data) {
    if (typeof data !== "object" || data === null)
        return false;
    const m = data;
    if (typeof m.type !== "string" || !MESSAGE_TYPE_SET.has(m.type))
        return false;
    if (typeof m.merchantId !== "string")
        return false;
    if (typeof m.timestamp !== "number")
        return false;
    if (typeof m.nonce !== "string")
        return false;
    if (m.clientId !== undefined && typeof m.clientId !== "string")
        return false;
    return true;
}
export function sendMessage(target, message, targetOrigin) {
    if (targetOrigin === "*") {
        throw new Error("sendMessage: targetOrigin must be an exact origin, not a wildcard.");
    }
    target.postMessage(message, targetOrigin);
}
// Listen for contract messages, accepting only the given trusted origins.
// Callers pass the exact origin(s) they embedded (SDK -> modal origin; modal ->
// its parent origin) instead of relying on a mutable shared constant.
export function receiveMessage(handler, trustedOrigins = ALLOWED_ORIGINS) {
    const listener = (event) => {
        if (!trustedOrigins.includes(event.origin)) {
            if (isValidMessage(event.data)) {
                console.warn(`[stealth] rejected ${event.data.type} from untrusted origin ${event.origin}`);
            }
            return;
        }
        if (!isValidMessage(event.data)) {
            // Trusted origin, but malformed/untyped — never act on a partial message.
            console.warn(`[stealth] dropped malformed message from ${event.origin}`);
            return;
        }
        handler(event.data);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
}
